export enum WalletTransactionState{
    Usable = 0,
    Locked = 1,
    DepositLocked = 2,
    WithdrawalLocked = 3,
    CurrencyDisabled = 4
}